<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Pull to Refresh Indicator -->
<div
  class="fixed left-0 right-0 z-50 flex justify-center items-center transition-transform duration-300 ease-out"
  [style.top.px]="headerHeight"
  [class.translate-y-0]="pullProgress > 0"
  [class.-translate-y-full]="pullProgress === 0"
  [style.transform]="getIndicatorTransform()"
>
  <div class="bg-white dark:bg-gray-800 rounded-full shadow-lg p-3 m-4">
    <mat-icon
      class="transition-transform duration-200"
      [class.animate-spin]="isRefreshing"
      [class.rotate-180]="pullProgress >= pullThreshold && !isRefreshing"
      [svgIcon]="isRefreshing ? 'heroicons_outline:arrow-path' : 'heroicons_outline:arrow-down'"
      color="primary">
    </mat-icon>
  </div>
</div>

<!-- Navigation -->
<fuse-vertical-navigation #fuseVerticalNav class="dark sidebar bg-primary print:hidden mt-0" [appearance]="navigationAppearance"
    [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'" [navigation]="navigation.default"
    [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex items-center justify-center mt-10">
            <div [ngClass]="club.styles.logo.size.sideBarTopLeft.classnameWidth">
                <app-logo></app-logo>
            </div>
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
    <!-- Header -->
    <div #headerElement class="header md:px-6 print:hidden" [ngClass]="{ scrolled: isScrolled }" fuseScrollReset>
        <div #menuBurger class="flex flex-1 items-center justify-start ml-2 mb-4">
            <!-- Navigation toggle button -->
            <button
                (click)="toggleNavigation('mainNavigation')"
                class="lg:hidden"
            >
                <div [ngClass]="club.styles.logo.size.eventCard.classnameWidth">
                    <app-logo></app-logo>
                </div>
            </button>
        </div>

        <div class="mx-1 p-1 flex-1">
            <!-- Navigation toggle button -->
            <div #logoContainer class="logo-container flex flex-col justify-center items-center w-full"
                [ngClass]="{ 'scrolled-logo': isScrolled }">
                <p class="flex-auto whitespace-nowrap text-white text-xl lg:text-base lg:font-medium club-name">
                </p>
            </div>
        </div>

        <!-- Components -->
        <div class="flex items-center justify-end flex-1 mr-2 mb-4">
            <notifications></notifications>
            <user></user>
        </div>
    </div>
    <!-- End Header -->

    <!--!! Content PRINCIPAL !!-->
    <div
      #contentElement
      class="flex flex-col flex-auto pt-24 mb-20 pb-3 w-full sm:pb-0 sm:mb-0 transition-transform duration-300 relative"
      [style.transform]="getContentTransform()"
      (touchstart)="onContentTouchStart($event)"
      (touchmove)="onContentTouchMove($event)"
      (touchend)="onContentTouchEnd($event)">

        <!-- Touch area for pull to refresh (invisible overlay at the top of content) -->
        <div
          class="absolute top-0 left-0 right-0 h-20 z-10 pointer-events-auto"
          [class.pointer-events-none]="pullProgress === 0">
        </div>

        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <div class="lg:pl-22 lg:pr-8 relative z-0">
            <app-breadcrumb></app-breadcrumb>
        </div>
        <div class="relative z-0">
            <router-outlet *ngIf="true"></router-outlet>
        </div>
    </div>
    <!-- End Content -->

    <!-- Footer pour mobile uniquement -->
    <div class="fixed z-99 w-full flex sm:hidden justify-center items-center md:px-6 bottom-0 dark:bg-transparent print:hidden"
        [ngClass]="isAndroidApp ? '' : 'h-20'">
        <app-footer class="w-full h-full"></app-footer>
    </div>

    <!-- Footer pour desktop uniquement -->
    <div class="hidden bg-black sm:flex justify-center h-7 items-center" id="footer">
        <button id="scrollButton" (click)="scrollToTop()">
            <mat-icon color="primary" [svgIcon]="'heroicons_solid:arrow-up-circle'"></mat-icon>
        </button>
        <span class="text-xs text-secondary">{{ clubName.name }} | &copy; {{ currentYear }}</span>
    </div>
</div>
